import { create } from 'zustand';
import { User } from '@packet/management/src/DTO/user';
import { getUserDetail } from '../api/user';

interface UserDetailModalState {
  isOpen: boolean;
  user: User | null;
  loading: boolean;
  error: string | null;
  openUserDetail: (id: number) => Promise<void>;
  closeUserDetail: () => void;
}

export const useUserDetailModalStore = create<UserDetailModalState>((set, get) => ({
  isOpen: false,
  user: null,
  loading: false,
  error: null,

  openUserDetail: async (id: number) => {
    set({
      isOpen: true,
      loading: true,
      error: null,
      user: null,
    });

    try {
      const response = await getUserDetail({ id });
      if (response.code === 0) {
        set({
          user: response.data,
          loading: false,
        });
      } else {
        set({
          error: response.message || '获取用户信息失败',
          loading: false,
        });
      }
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : '获取用户信息失败',
        loading: false,
      });
    }
  },

  closeUserDetail: () => {
    set({
      isOpen: false,
      user: null,
      loading: false,
      error: null,
    });
  },
}));
